<template>
  <div class="enhancements-selected">
    <div class="enhancements-selected-wrapper" :class="[{'multibooking-active': multiBookingIsActive}]">
      <div class="enhancements-selected-header">Want to change your privileges? Simply remove to choose another.</div>
      <ul>
        <enhancement-card
          v-for="enhancement in selectedEnhancements"
          :key="enhancement.sitecoreId"
          :enhancement="enhancement"
          @remove-enhancement="$emit('remove-enhancement', $event)"
          @edit-enhancement="$emit('edit-enhancement', $event)"
        />
      </ul>
      <div class="enhancements-multibooking form" v-if="multiBookingIsActive">
        <label>
          <input
            id="enhancements-multibooking-checkbox"
            name="enhancements_multibooking_checkbox"
            type="checkbox"
            :checked="multiBookingCheckboxIsActive"
            @input="onAction"
          />
            {{tc('booking.multiBookingCheckboxLabel')}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
  import EnhancementCard from './enhancement-card.vue'

  export default {
    name: 'enhancements-selected',
    components: {
      EnhancementCard
    },
    props: {
      selected: {
        type: Array,
        default: () => []
      },
    },
    computed: {
      ...mapState('cart', ['roomEnhancements', 'enhancementsMultiBookingSelected', 'enhancementsMultiBookingAvailable']),
      ...mapGetters('i18n', ['tc']),
      selectedEnhancements() {
        return this.selected.map((s) => {
          const enhancement = this.roomEnhancements.find((e) => e.sitecoreId === s.sitecoreId)
          return {
            ...enhancement,
            ...s
          }
        })
      },
      multiBookingCheckboxIsActive: {
        get() {
          return this.enhancementsMultiBookingSelected
        },
        set(val) {
          this.selectEnhancementsForMultiBooking(val)
        }
      },
      multiBookingIsActive() {
        return this.enhancementsMultiBookingAvailable
      }
    },
    mounted() {
      this.enhancementsMultiBookingAvailability()
    },
    methods: {
      ...mapActions('cart', ['selectEnhancementsForMultiBooking', 'enhancementsMultiBookingAvailability']),
      onAction(event) {
        this.multiBookingCheckboxIsActive = event.target.checked
      }
    }
  }
</script>
